import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IHeaderForm } from '../../entities/header-entity';
import { Factory } from '../factory';
import { IAccessibleImageForm } from '../../entities/image-entity';
import { DEFAULT_HEADER, IHeader } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class HeaderFormsFactoryService extends Factory<IHeaderForm, IHeader> {
  formBuilder: FormBuilder = inject(FormBuilder);

  buildForm(entity: IHeader = DEFAULT_HEADER): FormGroup<IHeaderForm> {
    return this.formBuilder.group<IHeaderForm>({
      id: this.formBuilder.control(entity.id || null),
      backgroundColor: this.formBuilder.nonNullable.control(
        entity.backgroundColor,
        [Validators.required]
      ),
      fontColor: this.formBuilder.nonNullable.control(entity.fontColor, [
        Validators.required,
      ]),
      logo: this.formBuilder.group<IAccessibleImageForm>({
        id: this.formBuilder.control(entity.logo.id || null),
        image: this.formBuilder.control(entity.logo.image, [
          Validators.required,
        ]),
        imageAlts: this.formBuilder.nonNullable.control(entity.logo.imageAlts, [
          Validators.required,
        ]),
        url: this.formBuilder.control(entity.logo.url || null),
        positionOrder: this.formBuilder.control(entity.logo.positionOrder, []),
      }),
      headlines: this.formBuilder.nonNullable.control(entity.headlines, []),
      headlineFontSize: this.formBuilder.nonNullable.control<number>(
        entity.headlineFontSize,
        [Validators.required]
      ),
      leftImage: this.formBuilder.group<IAccessibleImageForm>({
        id: this.formBuilder.control(entity.leftImage.id || null),
        image: this.formBuilder.control(entity.leftImage.image),
        imageAlts: this.formBuilder.nonNullable.control(
          entity.leftImage.imageAlts
        ),
        url: this.formBuilder.control(entity.leftImage.url || null),
        positionOrder: this.formBuilder.nonNullable.control(
          entity.leftImage.positionOrder
        ),
      }),
      rightImage: this.formBuilder.group<IAccessibleImageForm>({
        id: this.formBuilder.control(entity.rightImage.id || null),
        image: this.formBuilder.control(entity.rightImage.image),
        imageAlts: this.formBuilder.nonNullable.control(
          entity.rightImage.imageAlts
        ),
        url: this.formBuilder.control(entity.rightImage.url || null),
        positionOrder: this.formBuilder.control(
          entity.rightImage.positionOrder
        ),
      }),
    });
  }

  buildEntity(form: FormGroup<IHeaderForm>): IHeader {
    const header = form.getRawValue() as IHeader;
    if (header.leftImage) {
      if (!header.leftImage.image) {
        header.leftImage.image = null;
      }
    }
    if (header.rightImage) {
      if (!header.rightImage.image) {
        header.rightImage.image = null;
      }
    }
    this.removeNullIds(header);
    return header as IHeader;
  }
}
